export default [
  {
    path: '/memberCenter', // 会员中心
    name: 'MEMBERCENTER',
    component: () => import('@/views/memberCenter/index'),
    meta: {
      title: '会员中心'
    }
  },
  {
    path: '/run/map', // 跑步
    name: 'RUNMAP',
    component: () => import('@/views/run/map.vue'),
    meta: {
      title: '跑步'
    }
  },
  {
    path: '/run/motionList', // 运动记录
    name: 'RUNMOTIONLIST',
    component: () => import('@/views/run/motionList.vue'),
    meta: {
      title: '运动记录'
    }
  },
  {
    path: '/member-product', // 会员套餐列表页
    name: 'MEMBERPRODUCT',
    component: () => import('@/views/member-product/index')
  },
  {
    path: '/member-product/detail/:category?/:prodCode?',
    name: 'MEMBERPRODUCTDETAIL',
    component: () => import('@/views/member-product/detail')
  },
  {
    path: '/payment/mode',
    name: 'PAYMENTMODE',
    component: () => import('@/views/payment/mode'),
    meta: {
      title: '收银台'
    }
  },
  {
    path: '/payment/complete/:id?',
    name: 'PAYMENTCOMPLETE',
    component: () => import('@/views/payment/complete'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/ownExpense/mealDetail',
    name: 'MEALDETAIL',
    component: () => import('@/views/ownExpense/mealDetail.vue')
  },
  {
    path: '/ownExpense/placeOrder',
    name: 'PLACEORDER',
    meta: {
      title: '订单中心'
    },
    component: () => import('@/views/ownExpense/placeOrder.vue')
  },
  {
    path: '/ownExpense/payCompletion',
    name: 'PAYCOMPLETION',
    meta: {
      title: '支付结束'
    },
    component: () => import('@/views/ownExpense/payCompletion.vue')
  },
  {
    path: '/ownExpense/orderDetails',
    name: 'ORDERDETAILS',
    meta: {
      title: '订单详情'
    },
    component: () => import('@/views/ownExpense/orderDetails.vue')
  },
  {
    path: '/ownExpense/orderList',
    name: 'ORDERLIST',
    meta: {
      title: '会员订单'
    },
    component: () => import('@/views/ownExpense/orderList.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/member.js